/**
 * Exchange rate configuration
 *
 * Centralized place to manage exchange rates for the application.
 * Update these values as needed to reflect current market rates.
 */

export default {
  // USD to KSH exchange rate
  USD_TO_KSH: 130,

  // You can add more currencies here in the future
  // EUR_TO_KSH: 140,
  // GBP_TO_KSH: 160,

  /**
   * Get the USD to KSH exchange rate
   * @returns {number} Current exchange rate
   */
  getUsdToKshRate() {
    return this.USD_TO_KSH;
  },

  /**
   * Convert USD amount to KSH
   * @param {number} usdAmount - Amount in USD
   * @returns {number} Amount in KSH
   */
  convertUsdToKsh(usdAmount) {
    return usdAmount * this.USD_TO_KSH;
  },

  /**
   * Convert KSH amount to USD
   * @param {number} kshAmount - Amount in KSH
   * @returns {number} Amount in USD
   */
  convertKshToUsd(kshAmount) {
    return kshAmount / this.USD_TO_KSH;
  },
};
